import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/app/components/ui/PageHeader';
import { renderLabel } from '@/i18n/renderLabel';

/**
 * A Beheer section that has a menu entry and a route, but no real screen
 * yet — System › Statistics (`/manage/system/statistics`), per
 * PLAN-FASE1.md § Beheer: "statistics: placeholder". Subscriptions used to
 * live here too but now has real screens under `src/manage/subscriptions/`.
 */
export function PlaceholderPage({ section }: { section: 'statistics' }) {
  const { t } = useTranslation();
  return (
    <section>
      <PageHeader
        title={renderLabel(t, `manage.placeholders.${section}.title`)}
        lead={renderLabel(t, `manage.placeholders.${section}.note`)}
      />
    </section>
  );
}
